var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { StringFormat } from './string';

var StringUrlFormat = function (_super) {
  __extends(StringUrlFormat, _super);

  function StringUrlFormat() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 对数据进行校验
   */


  StringUrlFormat.prototype.validate = function (_rule, value, callback) {
    // var url = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
    if (value && typeof value !== 'string') {
      // if (value && typeof value !== 'string' && !url.test(value)) {
      callback('The input is not valid Url!');
    } else {
      callback();
    }
  };

  return StringUrlFormat;
}(StringFormat);

export { StringUrlFormat };